import React from 'react';
import './TestProjektBadge.css';

/**
 * TEST-etikett för projekt utan koppling till Hogia.
 *
 * hogia_linked kommer från GET /projects/ och GET /projects/{id}:
 * false = saknar koppling (testprojekt), true = Hogia-kopplat,
 * null/undefined = okänt eller organisationen har ingen Hogia (ingen etikett).
 *
 * @param {{ storlek?: 'sm' | 'md', className?: string }} props
 */
export function arTestprojekt(projekt) {
  return projekt?.hogia_linked === false;
}

export default function TestProjektBadge({ storlek = 'sm', className = '' }) {
  return (
    <span
      className={`kp-test-badge kp-test-badge--${storlek} ${className}`.trim()}
      title="Testprojekt utan koppling till Hogia. Rapportera inte riktig tid eller riktiga utlägg här."
    >
      TEST
    </span>
  );
}
